// Product media (variant images) and videos share one `imageUrls` array — a
// video is just a URL with a video extension. Detect it by extension so we can
// render <video> instead of <img> without any schema/type field.
const VIDEO_EXT = /\.(mp4|webm|mov|m4v|ogg)(\?|#|$)/i;

export const isVideoUrl = (url) => typeof url === 'string' && VIDEO_EXT.test(url);
